import React from 'react'
import { createTheme } from '@mui/material'

const Theme = createTheme({
    typography: {
      fontFamily: '"Pontano Sans", sans-serif'
    },
    
  });
  
export default Theme;
